import { fork, ChildProcess } from 'child_process';
import {EventEmitter} from 'events';
import {fileURLToPath} from 'url';

type ProcessMessage = {
    type: 'error' | 'message'
    message: string
    data?: unknown
}

export class NodeWorker implements Worker {
    private readonly events = new EventEmitter();
    private readonly ps: ChildProcess;
    constructor(url: string | URL, args: readonly string[], options?) {
        this.events = new EventEmitter();
        const modulePath = fileURLToPath(url);
        this.ps = fork(modulePath, args, options);
        this.ps.on('message', (message: string) => {
            let parsed: ProcessMessage;
            try {
                parsed = JSON.parse(message) as ProcessMessage;
                if (parsed?.type === undefined) {
                    this.events.emit('messageerror', new Error(`Invalid message: ${message}`));
                }
            } catch (e) {
                this.events.emit('messageerror', e);
                return;
            }
            if (parsed.type === 'error') {
                this.events.emit('error', new Error(parsed.message));
            } else {
                this.events.emit('message', {data: parsed.data});
            }
        });
        this.ps.stdout?.on('data', (data) => {
            console.log(data);
        });
        this.ps.stderr?.on('data', (data) => {
            console.error(data);
        });
        this.ps.on('error', (error) => {
            this.events.emit('error', error);
        });
        this.events.on('message', (message) => {
            if (this.onmessage) {
                this.onmessage(message);
            }
        });
        this.events.on('error', (error) => {
            if (this.onerror) {
                this.onerror(error);
            }
        });
        this.events.on('messageerror', (error) => {
            if (this.onmessageerror) {
                this.onmessageerror(error);
            }
        });

    }
    onerror: ((error) => void) | null = null;
    onmessage: ((message) => void) | null = null;
    onmessageerror: ((error) => void) | null = null;


    postMessage(message: unknown): void {
        this.ps.send({data: message}, (error) =>{
            if (error) {
                this.events.emit('error', error);
            }
        });
    }

    terminate(): void {
        this.ps.kill();
    }

    addEventListener<K extends keyof WorkerEventMap>(type: K, listener: (this: Worker, ev: WorkerEventMap[K]) => unknown, options?: boolean | AddEventListenerOptions): void {
        this.events.addListener(type, listener);
    }
    removeEventListener<K extends keyof WorkerEventMap>(type: K, listener: (this: Worker, ev: WorkerEventMap[K]) => unknown, options?: boolean | EventListenerOptions): void {
        this.events.removeListener(type, listener);
    }

    dispatchEvent(event: Event): boolean {
        return this.events.emit(event.type, event);
    }
}
